// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content {
  display: flex;
  gap: 16px;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 24px;
  cursor: auto;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-paragraph span {
  font-weight: 400;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-paragraph span:before {
  content: ' ';
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-col {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-button {
  color: var(--color-highlight-lighter);
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-button .vert-icon svg {
  fill: var(--color-highlight-lighter);
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-button:hover {
  color: var(--color-highlight-darker) !important;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .vert-button:hover .vert-icon svg {
  fill: var(--color-highlight-darker);
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content.add-addres-button {
  color: var(--color-neutral-light, #b9bec9) !important;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content.add-addres-button .vert-icon svg {
  fill: var(--color-neutral-light);
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content.add-addres-button:hover {
  color: var(--color-neutral-darker, #b9bec9) !important;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content.add-addres-button:hover .vert-icon svg {
  fill: var(--color-neutral-darker);
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .content-buttons {
  display: block;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .ant-radio-inner {
  border-color: var(--color-detached) !important;
}
.checkout-delivery-adress-infos-wrapper .checkout-delivery-adress-infos-content .ant-radio-inner::after {
  background-color: var(--color-detached) !important;
}
@media screen and (max-width: 768px) {
  .checkout-delivery-adress-infos-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
  .checkout-delivery-adress-infos-content .content-buttons {
    display: flex !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/DeliveryAddressInfosStyles.less"],"names":[],"mappings":"AACA;EAEI,aAAA;EACA,SAAA;AADJ;AAFA;EAOM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAFN;AARA;EAYQ,gBAAA;AADR;AAEQ;EACE,YAAA;AAAV;AAdA;EAoBM,0BAAA;EACA,2BAAA;AAHN;AAlBA;EAwBM,qCAAA;AAHN;AArBA;EA0BQ,oCAAA;AAFR;AAKM;EACE,+CAAA;AAHR;AAEM;EAGI,mCAAA;AAFV;AAOI;EACE,qDAAA;AALN;AAII;EAGI,gCAAA;AAJR;AAMM;EACE,sDAAA;AAJR;AAGM;EAGI,iCAAA;AAHV;AA1CA;EAkDM,cAAA;AALN;AA7CA;EAsDM,8CAAA;AANN;AAQM;EACE,kDAAA;AANR;AAaA;EACE;IACE,6BAAA;IACA,0CAAA;EAXF;EAaA;IAEI,wBAAA;EAZJ;AACF","sourcesContent":["// DESKTOP\n.checkout-delivery-adress-infos-wrapper {\n  .checkout-delivery-adress-infos-content {\n    display: flex;\n    gap: 16px;\n    // flex-wrap: wrap;\n\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 500;\n      line-height: 24px;\n      cursor: auto;\n      span {\n        font-weight: 400;\n        &:before {\n          content: ' ';\n        }\n      }\n    }\n\n    .vert-col {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n    .vert-button {\n      color: var(--color-highlight-lighter);\n      .vert-icon svg {\n        fill: var(--color-highlight-lighter);\n      }\n\n      &:hover {\n        color: var(--color-highlight-darker) !important;\n        .vert-icon svg {\n          fill: var(--color-highlight-darker);\n        }\n      }\n    }\n\n    &.add-addres-button {\n      color: var(--color-neutral-light, #b9bec9) !important;\n      .vert-icon svg {\n        fill: var(--color-neutral-light);\n      }\n      &:hover {\n        color: var(--color-neutral-darker, #b9bec9) !important;\n        .vert-icon svg {\n          fill: var(--color-neutral-darker);\n        }\n      }\n    }\n    .content-buttons {\n      display: block;\n    }\n\n    .ant-radio-inner {\n      border-color: var(--color-detached) !important;\n\n      &::after {\n        background-color: var(--color-detached) !important;\n      }\n    }\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-delivery-adress-infos-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n  }\n  .checkout-delivery-adress-infos-content {\n    .content-buttons {\n      display: flex !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
